// @flow
import type { TemplateNode } from 'lib/digital_file/model'

export const findLabels = (
  nodes: Array<TemplateNode>,
  slugs: Array<string>,
): Array<string> => {
  if (slugs.length === 0) return []
  const [head, ...rest] = slugs
  for (const node of nodes) {
    if (node.slug === head) {
      return [node.label, ...findLabels(node.children || [], rest)]
    }
  }
  return []
}

export const labelPath = (
  template: Array<TemplateNode>,
  path: ?string,
): string => {
  if (!path) return ''
  return findLabels(template, path.split('|')).join(' › ')
}
